<template>
    <SplitLayout class="c-account" :left-props="{class : 'c-account-left-col py-0'}" :right-props="{class : 'c-account-right-col px-0 px-md-2 py-md-0'}">
        <template v-slot:left>
         <div class="c-account__left-side relative">
             <div v-show="$vuetify.breakpoint.mdAndUp" class="c-account__welcome font-family-futura">
                 <h1 class="text-welcome color-coro-red">{{ imageHeader1 }}</h1>
                 <h2 class="text-welcome color-coro-brown">{{ imageHeader2 }}</h2>
             </div>
             <v-img :src="imageUrl" :aspect-ratio="imageAspectRatio" :title="imageHeader1" :alt="imageHeader1"></v-img>
         </div>
        </template>
        <template v-slot:right>
            <div class="c-account__right-side">
                <div class="c-account__box c-account__title-box box-default ">
                    <h2 class="text-center"><i :class="logoClasses"/>
                        <br v-if="breakAfterLogo" />
                        <span class="c-account__text-coro text-coro middle">
                            {{ header1 }}
                            <span style="display: block; font-size: 16px; font-weight: 400">
                                {{ versionInfo }}
                            </span>
                        </span>
                    </h2>
                </div>
                <div class="c-account__box box-default login-box">
                    <slot></slot>
                </div>
            </div>
        </template>
    </SplitLayout>
</template>

<script>
import SplitLayout from "../../layout/SplitLayout";

/**
 * Component Account.vue
 *
 * @module Account
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/APP_DASHBOARD/templates/components/Account/Account.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'Account',
  components: {
    SplitLayout,
  },
  props : {
    imageHeader1: {
      type: String,
    },
    imageHeader2: {
      type: String,
    },
    imageUrl: {
      type: String,
    },
    header1: {
      type: String,
    },
    versionInfo: {
      type: String,
    },
    imageAspectRatio: {
      type: Number,
    },
    breakAfterLogo: {
      type: Boolean,
    },
  },
  computed: {
    logoClasses() {
      const classes = [
        'c-account__icon-coro',
        'icon-coro',
        'middle'
      ]

      if (!this.$store.getters['isTestingEnvironment']) {
        classes.push('icon-coro--prod');
      }

      return classes;
    }
  }
}
</script>

<style lang="scss">
    // mobile first
    .c-account{
        padding-top: 0;
    }

    .c-account-left-col{
        background: #fdf9fa;
    }

    .c-account__right-side{
        background: #fff;
        overflow: hidden;
        border-radius: 22px;
        margin-top: -30px;
    }

    .c-account__left-side{
        margin-bottom: 40px;
    }

    .c-account__box {
        padding: 20px;
        overflow: hidden;
    }

    .c-account_icon-coro{
        margin-right: 8px;
    }

    .c-account_text-coro{
        line-height: 2em;
    }

    .c-account__welcome{
        margin: 49px 0 120px 85px;

        h2{
            margin-top: 5px;
        }
    }

    // mobile screens
    .v-application.sm-down{
        .c-account__box{
            border: none;
        }
    }

    // tablet screens
    .v-application.md-up{
        .c-account__right-side {
            padding-left: 2%;
            width: 95%;
            margin-top: 0;
        }

        .c-account__title-box {
            padding: 47px 0;
            margin-bottom: 40px;
        }

        .c-account-left-col{
            border-radius: 22px;
        }
    }

    // desktop/large screens
    .v-application.lg-up{
        .c-account__box {
            padding-left: 13%;
            padding-right: 13%;
        }
        .c-account__welcome{
            margin-bottom: 18px;
        }
        .c-account__left-side{
            margin-bottom: 0;
        }
    }

    // -------------------------------------------------- BEM modifiers ------------------------------------------------

    //BEM modifier - reset password/request new password
    .c-account--resetpassword, .c-account--requestnewpassword{
        .c-account__left-side{
            margin-bottom: 18px;
        }
    }
</style>